var exports = {
  "k": "x234b8571--89e58e--container",
};

module.exports = exports;
